<div class="div-cananas">
    <canvas class="signature-pad-canvas"></canvas>
</div>